// Auth Flow Configuration
// Toggle between "signup_first" and "payment_first" via REACT_APP_AUTH_FLOW env var

export type AuthFlowType = 'signup_first' | 'payment_first';

export const AUTH_FLOW: AuthFlowType = (
  process.env.REACT_APP_AUTH_FLOW as AuthFlowType
) || 'signup_first';

export const authFlowConfig = {
  // OPÇÃO 1: Signup First
  // Fluxo: Assistir → Cadastro/Login → Login Auto → Planos → Comprar PIX
  signup_first: {
    name: 'Signup First',
    description: 'User signs up first, then accesses plans and pays',
    headerButtonLabel: 'Assistir',
    showBuyButtonEverywhere: false,
    requiresAuthBeforePlans: true,
    autoLoginAfterSignup: true,
  },

  // OPÇÃO 2: Payment First
  // Fluxo: Comprar em toda tela → PIX gerado com session UUID → Webhook → Finalizar cadastro
  payment_first: {
    name: 'Payment First',
    description: 'User pays first with session UUID, then signs up after webhook',
    headerButtonLabel: 'Entrar',
    showBuyButtonEverywhere: true,
    requiresAuthBeforePlans: false,
    autoLoginAfterSignup: false,
  },
};

export const getCurrentFlowConfig = () => authFlowConfig[AUTH_FLOW];

export const isSignupFirstFlow = () => AUTH_FLOW === 'signup_first';
export const isPaymentFirstFlow = () => AUTH_FLOW === 'payment_first';
